import React, {useState} from 'react'
import roomPreviewUserIcon from '../../../../../_metronic/assets/images/svg/data-room/room-preview-user-icon.svg'
import OutsideClickHandler from 'react-outside-click-handler'
import {RoomPreviewDropdown} from './RoomPreviewDropdown'
import {DisplayImage} from '../../../widgets/components/General/DisplayImage'
export default function RoomPreviewHeader({
  companyName,
  userFirstName,
  userLastName,
  userEmail,
  userIcon,
  companyUrl,
  companyIcon,
}: {
  companyName: string
  userFirstName: string
  userLastName: string
  userEmail: string
  userIcon: string
  companyUrl: string
  companyIcon: string
}) {
  const [menuOpen, setMenuOpen] = useState(false)
  return (
    <div className='room-preview-header-wrapper btn-bg-white d-flex flex-row align-items-center justify-content-between'>
      <div className='d-flex flex-row align-items-center'>
        <DisplayImage
          imgName={companyIcon}
          width='100%'
          alt='profile'
          fit='contain'
          height='50px'
        />
        <h4 className='mb-0 flex-shrink-0 dark_text_color'>{companyName}</h4>
      </div>

      <div className='preview-user-dropdown-wrapper'>
        <OutsideClickHandler onOutsideClick={() => setMenuOpen(false)}>
          <img
            src={roomPreviewUserIcon}
            className='user-dropdown-btn'
            alt=''
            onClick={() => setMenuOpen(!menuOpen)}
          ></img>
          <RoomPreviewDropdown
            isOpen={menuOpen}
            userFirstName={userFirstName}
            userLastName={userLastName}
            userEmail={userEmail}
            companyUrl={companyUrl}
            userIcon={userIcon}
          />
        </OutsideClickHandler>
      </div>
    </div>
  )
}
